import { Player } from 'tone';
import { BasePlayer } from "./BasePlayer";
import { shuffleArray } from "@/functions";
export class EffectsPlayer extends BasePlayer {
    constructor({ path, name, input, config }) {
        super({ path, name, input, config });
        this._effectIndex = 0;
        const { effectPool } = config;
        // Shuffle if required
        this._effectPool = config.random ? shuffleArray(effectPool) : effectPool;
        this.player = new Player({
            loop: false,
            autostart: false,
            url: this.currentSrc,
            volume: this.currentVolume,
            onload: () => this.onPlayerLoaded(),
            onstop: () => this.onPlayerStopped(),
        });
    }
    onPlayerLoaded() {
        clearTimeout(this._timeout);
        if (this._playRequestedAt && this.isConnected) {
            const { delay, volume } = this.currentEffect;
            // Either play now or after the relative delay
            if (delay) {
                const now = new Date().getTime();
                const relativeDelay = Math.max(0, delay * 1000 - (now - this._playRequestedAt));
                this._timeout = setTimeout(() => this.player.start(), relativeDelay);
            }
            else {
                this.player.start();
            }
            if (volume !== undefined) {
                this.fadeVolumeTo({ volume, duration: this.config.fadeInDuration || 1 });
            }
            this._playRequestedAt = null;
        }
    }
    onPlayerStopped() {
        if (!this.isConnected) {
            return;
        }
        const config = this.config;
        if (config.followAction === "chain" && this.isConnected) {
            this._effectIndex = (this._effectIndex + 1) % this._effectPool.length;
            this._playRequestedAt = new Date().getTime();
            this.player.load(this.currentSrc).then(() => console.log("Loaded after stop", this.currentSrc));
        }
    }
    enterScene(scene) {
        console.log("Effects player", this.name, "Entering scene", scene.name);
        console.log("State: ", this.player.state, this.player.loaded ? "loaded" : "not loaded");
        if (this.player.loaded) {
            this.player.start(0);
        }
        else {
            this._playRequestedAt = new Date().getTime();
        }
    }
    get currentEffect() {
        return this._effectPool[this._effectIndex];
    }
    get currentSrc() {
        const { src } = this.currentEffect;
        return `./audio/${this.path}/${src}.mp3`;
    }
    get currentVolume() {
        return this.currentEffect.volume || this.config.volume || -6;
    }
}
